import { render } from "./AvatarText.vue?vue&type=template&id=145f9153"
import script from "./AvatarText.vue?vue&type=script&lang=js"
export * from "./AvatarText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__